var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMercuryFeaturesCard3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 172,
    viewBox: "0 0 166 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1103 14.898L22.906 32.4546C11.0777 40.6938 22.9064 77.1883 49.3729 113.815C75.8393 150.442 106.847 173.576 118.676 165.337L143.867 147.858L48.1103 14.898Z",
    fill: "#AA14F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.523 147.062C156.252 138.682 143.969 102.402 117.087 66.027C90.2058 29.6524 58.9058 6.95834 47.1766 15.3384C35.4475 23.7184 47.7308 59.9991 74.6122 96.3737C101.494 132.748 132.794 155.442 144.523 147.062Z",
    fill: "url(#paint0_linear_944_144)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_944_144",
    x1: -56.7037,
    y1: -125.227,
    x2: 56.5216,
    y2: -157.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercuryFeaturesCard3);
export default __webpack_public_path__ + "static/media/mercury_features_card3.61beec768046b5e0cb31d468a7cce9fc.svg";
export { ForwardRef as ReactComponent };